import { Directive, ElementRef, OnInit, ComponentFactoryResolver, ViewContainerRef, Injector, ComponentRef, ViewChild } from '@angular/core';
import { TimezoneComponent } from './timezone.component';


@Directive({ selector: '[customattach]'})
export class TimezoneDirective {   
//     private componentRef: ComponentRef<TimezoneComponent>;
//     @ViewChild('ngx-daterangepicker-material') picker: ElementRef;
//     constructor( private el: ElementRef,
//     private viewContainerRef: ViewContainerRef) {
//         console.log(this.picker, "qqqqqqqqqqqqqqqq")
//       }

//     ngOnInit(): void {
//         this.componentRef = this.viewContainerRef.createComponent(TimezoneComponent);
//     }

//     ngOnDestroy() {
//     // Clean up the component when directive is destroyed
//     if (this.componentRef) {
//       this.componentRef.destroy();
//     }
//   }
 }

